'use client'

import type { ToasterProps } from 'sonner'
import * as React from 'react'
import { CircleCheckIcon, InfoIcon, Loader2Icon, OctagonXIcon, TriangleAlertIcon } from 'lucide-react'
import { Toaster as Sonner, toast } from 'sonner'

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      theme='light'
      className='ui:toaster ui:group ui:z-99999'
      icons={{
        success: <CircleCheckIcon className='ui:text-main-blue-75 ui:size-4' />,
        info: <InfoIcon className='ui:text-neutrals-white ui:size-4' />,
        warning: <TriangleAlertIcon className='ui:text-neutrals-white ui:size-4' />,
        error: <OctagonXIcon className='ui:text-main-red-75 ui:size-4' />,
        loading: <Loader2Icon className='ui:size-4 ui:animate-spin' />,
      }}
      style={
        {
          '--normal-bg': 'var(--neutrals-nvar-100)',
          '--normal-text': 'var(--neutrals-white)',
          '--normal-border': 'var(--border)',
          '--border-radius': 'var(--radius)',
        } as React.CSSProperties
      }
      toastOptions={{
        classNames: {
          toast:
            'ui:group ui:toast ui:group-[.toaster]:bg-neutrals-nvar-75 ui:group-[.toaster]:text-neutrals-white ui:group-[.toaster]:border-none ui:group-[.toaster]:shadow-lg ui:group-[.toaster]:rounded-lg',
          description: 'ui:group-[.toast]:text-neutrals-white',
          //   actionButton: 'ui:group-[.toast]:bg-primary ui:group-[.toast]:text-primary-foreground',
          //   cancelButton: 'ui:group-[.toast]:bg-muted ui:group-[.toast]:text-neutrals-n-75',
        },
      }}
      {...props}
    />
  )
}

export { Toaster, toast }
